<template>
  <AtroContent col class="h-screen w-full pb-14" items="center" wrap="nowrap">
    <AtroIcon class="my-14 w-[124px] text-atro-purple" name="atro_logo_horizontal" />
    <AtroContent class="h-full flex-shrink" items="center" justify="center">
      <AtroIcon class="h-full" name="404" />
    </AtroContent>
  </AtroContent>
</template>
